import React, { useEffect, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FaHome, FaPlus, FaUser, FaFileAlt, FaMicrochip, FaSignOutAlt, FaPills, FaListAlt } from "react-icons/fa";
import "./Menu.scss";

const Menu = React.memo(({ isOpen }) => {
  const navigate = useNavigate();
  const sidebarRef = useRef(null);
  const [hideCompletely, setHideCompletely] = React.useState(!isOpen);

  // Gerenciamento de visibilidade aprimorado
  useEffect(() => {
    const sidebar = sidebarRef.current;
    if (!sidebar) return;

    if (!isOpen) {
      // Esconde completamente após a transição
      const handleTransitionEnd = () => {
        if (!isOpen) {
          setHideCompletely(true);
        }
      };
      
      sidebar.addEventListener('transitionend', handleTransitionEnd);
      
      return () => {
        sidebar.removeEventListener('transitionend', handleTransitionEnd);
      };
    } else {
      // Mostra a barra lateral imediatamente
      setHideCompletely(false);
    }
  }, [isOpen]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  // Se deve esconder completamente, não renderiza nada
  if (hideCompletely && !isOpen) {
    return null;
  }

  return (
    <nav ref={sidebarRef} className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="sidebar__logo">
        <img src="/logo192.png" alt="DoseCerta Logo" className="sidebar__logo-image" />
      </div>
      <ul className="sidebar__menu">
        <li>
          <NavLink to="/home" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaHome className="menu-icon" /> Home
          </NavLink>
        </li>
        <li>
          <NavLink to="/adicionar-medicamento" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaPills className="menu-icon" /> Adicionar Medicamentos
          </NavLink>
        </li>
        <li>
          <NavLink to="/dispositivo" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaMicrochip className="menu-icon" /> Dispositivo
          </NavLink>
        </li>
        <li>
          <NavLink to="/perfil" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaUser className="menu-icon" /> Perfil
          </NavLink>
        </li>
        <li>
          <NavLink to="/relatorio" className={({ isActive }) => (isActive ? 'active' : '')}>
            <FaFileAlt className="menu-icon" /> Catálogo de Medicamentos
          </NavLink>
        </li>
        <li className="logout-item">
          <button onClick={handleLogout} className="logout-button">
            <FaSignOutAlt className="menu-icon" /> Sair
          </button>
        </li>
      </ul>
    </nav>
  );
});

export default Menu;